<template>
  <div class="d-flex justify-content-end pagination-custom">
    <b-button-group>
      <b-button-group v-b-tooltip.hover.nofade="toolTipDelay" :title="showAllRowsToolTip ? showAllRowsToolTip : $t('Webportal.ShowAllRows')">
        <b-button variant="secondary"
                  :disabled="disabled || isLoadAllDisabled"
                  @click="changePageSize(PageSizeMaximum)">
          {{ $n(this.totalCount) }}
        </b-button>
      </b-button-group>
      <b-dropdown :disabled="disabled" class="ml-1"
        v-b-tooltip.hover.nofade="toolTipDelay" :title="limitRowsToolTip ? limitRowsToolTip : $t('Webportal.LimitRows')">
        <template slot="button-content">
          <font-awesome-icon :icon="['far', 'bars']" /> {{ getPageSizeText(selectedPageSizeInternal) }}
        </template>
        <b-dropdown-item v-for="pageSize in pageSizes" :key="pageSize"
          @click="changePageSize(pageSize)">
          {{ getPageSizeText(pageSize) }}
        </b-dropdown-item>
      </b-dropdown>
    </b-button-group>
    <b-pagination v-model="valueInternal" class="mb-0"
                  :total-rows="totalCount"
                  :per-page="selectedPageSizeInternal"
                  :limit="limit"
                  :disabled="disabled"
                  @change="onInput" />
  </div>
</template>

<script>
  const PAGE_SIZE_DEFAULT = 20;
  const PAGE_SIZE_MAXIMUM = 999999;

  import AppConfig from '@/mixins/AppConfig'

  export default {
    name: "Pagination",

    mixins: [ AppConfig ],

    props: {
      value: { type: Number },                    // Number of the page, that is currently visible
      selectedPageSize: { type: Number },         // Number of items on one page of the table
      totalCount: { type: Number, default: 0 },   // Number of total items
      limit: { type: Number, default: 5 },
      disabled: { type: Boolean, default: false },
      showAllRowsToolTip: { type: String, default: null },
      limitRowsToolTip: { type: String, default: null }
    },

    data() {
      return {
        PageSizeMaximum: PAGE_SIZE_MAXIMUM,

        selectedPageSizeInternal: this.selectedPageSize,
        valueInternal: this.value,

        pageSizes: [20, 50, 100, 200, 500, 1000, PAGE_SIZE_MAXIMUM],
      };
    },

    created() {
      this.valueInternal = this.valueInternal ?? 1;
      this.selectedPageSizeInternal = this.selectedPageSizeInternal ?? PAGE_SIZE_DEFAULT;
    },

    computed: {
      isLoadAllDisabled: function () {
        return this.totalCount <= this.selectedPageSize || this.selectedPageSize === this.maximumPageSize;
      },
    },

    watch: {
      value(newVal, oldVal) {
        this.valueInternal = newVal;
      },

      valueInternal(newVal, oldVal) {
        if (newVal != oldVal)
          this.onInput(newVal);
      },

      selectedPageSize(newVal, oldVal) {
        this.selectedPageSizeInternal = newVal;
      },

      selectedPageSizeInternal(newVal, oldVal) {
        if (newVal != oldVal)
          this.onSelectedPageSizeChanged(newVal);
      }
    },

    methods: {
      onInput(page) {
        this.$emit("input", page ?? this.value);
      },

      onSelectedPageSizeChanged(pageSize) {
        this.$emit("update:selectedPageSize", pageSize);
      },

      getPageSizeText(pageSize) {
        return pageSize != PAGE_SIZE_MAXIMUM ? pageSize : this.$t('Webportal.Unlimited');
      },

      changePageSize(pageSize) {
        let hasChanged = this.valueInternal != 1 || this.selectedPageSizeInternal != pageSize;
        
        this.onSelectedPageSizeChanged(pageSize);
        this.valueInternal = 1;

        if (hasChanged)
          this.onInput();
      },

      resetPaging() {
        this.changePageSize(this.selectedPageSizeInternal != PAGE_SIZE_MAXIMUM ? this.selectedPageSizeInternal : PAGE_SIZE_DEFAULT);
      }
    }
  };
</script>